import { HttpClient } from '@/shared/lib/http-client';

export const fetchLastNews = async () => {
  const NEWS_COUNT = 4;

  const response = await HttpClient.get('/articles', {
    limit: NEWS_COUNT,
  });

  return response.data?.data;
};
